export const LINE_LIMIT_RANDOM_NAME = 20;
export const LINE_LIMIT_SPINNER = 20;
export const LINE_LIMIT_CHECK_IN = 20;
export const TOTAL_LINE_LIMIT_SPINNER = 35;
export const TOTAL_LINE_LIMIT_CHECK_IN = 35;

export interface ValidationLimitProps {
  value: string;
  lineLimit?: number;
  totalLineLimit?: number;
}

export const convertWordsByParams = ({
  value,
  lineLimit,
  totalLineLimit,
}: Required<ValidationLimitProps>) => {
  const items: string[] = value.split("\n");

  const convertToTotalLineLimit = items.slice(0, totalLineLimit);
  const convertToLineLimit = convertToTotalLineLimit.map((word) => word.substring(0, lineLimit));

  return convertToLineLimit.join("\n");
};

export const validationLimits = ({ value, lineLimit, totalLineLimit }: ValidationLimitProps) => {
  const items: string[] = value!.split("\n");
  let isValid = true;

  if (totalLineLimit && items.length > totalLineLimit) {
    isValid = false;
  }

  if (lineLimit) {
    for (let i = 0; i < value.length; i++) {
      if (value[i].length > lineLimit) {
        isValid = false;
      }
    }
  }

  return isValid;
};
